// Is a place photo the person's own, or from the web? (4.10.55, 2026-10-28)
// Decided by where it is stored: the person's photos come from their Google
// Drive ("gdrive:…", drive.google.com, lh3.googleusercontent.com/d/…), an
// upload in the app (Firebase Storage) or, in very old guides, the original
// app's upload folder (liquidguides.com/Media/Photos). Everything else —
// Wikipedia/Wikimedia, Google place photos, Flickr, the Featured guides'
// andiamotravelapp.com/Images, any other site — is a web photo.
// Shown only in review dialogs (Identify Places), never in the itinerary or
// on the map. A copied guide keeps the original owner's Drive photos, which
// still count as "own" here. Kept identical in andiamo-web and andiamo-places.

const OWN = [
  /^gdrive:/i,
  /^https?:\/\/(drive|docs)\.google\.com\//i,
  /^https?:\/\/lh3\.googleusercontent\.com\/d\//i,
  /^https?:\/\/firebasestorage\.googleapis\.com\//i,
  /^https?:\/\/[^/]+\.appspot\.com\//i,
  /^https?:\/\/(www\.)?liquidguides\.com\/+Media\/Photos\//i,
];

export function isOwnPhoto(url) {
  const u = String(url || "").trim();
  if (!u) return false;
  if (!/^[a-z]+:/i.test(u)) return true; // a bare file name: an old upload of the person's
  return OWN.some((re) => re.test(u));
}

export function isWebPhoto(url) {
  const u = String(url || "").trim();
  return u !== "" && !isOwnPhoto(u);
}
